import React, { useContext } from 'react';
import BruceModeContext from '../contexts/BruceModeContext';



const Loader = () => {
    const [bM, setBM] = useContext(BruceModeContext);
    let colors = bM.isBruce ? ['gray'] : ['red', 'yellow', 'green', 'blue', 'purple', 'orange', 'tomato', 'papaya', 'gold', 'cyan', 'darkblue', 'darkgreen', 'darkmagenta', 'darkorchid', 'darkred', 'darkgoldenrod', 'aliceblue', 'maroon', 'rebeccapurple'];
    return (
        <div id="barrier" onClick={(e) => e.stopPropagation()}>
            <div id="loader">
                <div className="inner one" style={bM.isBruce ? {borderColor: 'gray'} : {borderColor: colors[Math.floor(colors.length * Math.random()) + 1]}}></div>
                <div className="inner two" style={bM.isBruce ? {borderColor: 'gray'} : {borderColor: colors[Math.floor(colors.length * Math.random()) + 1]}}></div>
                <div className="inner three" style={bM.isBruce ? {borderColor: 'gray'} : {borderColor: colors[Math.floor(colors.length * Math.random()) + 1]}}></div>
            </div>
        </div>
    );
};

export default Loader;
